module.exports = __webpack_public_path__ + "static/assetclassenglish-8037e32a0c0b727bd1d87c134ee44632.png";